export const formatApartmentNumber = (floor: number, apartmentNumber: number): string => {
  // Für alle Etagen verwenden wir das Format: 3-stellige Etagennummer + "-" + 3-stellige Wohnungsnummer
  // Beispiel: 2. OG, Wohnung 1 = "002-001"
  // Beispiel: EG, Wohnung 3 = "000-003"
  // Beispiel: 1. UG, Wohnung 2 = "-01-002" (negative Zahlen für UG)
  
  // Etagennummer formatieren (3-stellig mit führenden Nullen)
  const floorStr = Math.abs(floor).toString().padStart(3, '0');
  const formattedFloor = floor < 0 ? `-${floorStr}` : floorStr;
  
  // Wohnungsnummer formatieren (3-stellig mit führenden Nullen)
  const aptStr = apartmentNumber.toString().padStart(3, '0');
  
  return `${formattedFloor}-${aptStr}`;
};

export const parseApartmentNumber = (formattedNumber: string): { floor: number; apartment: number } => {
  const parts = formattedNumber.split('-');
  
  // Behandlung von negativen Etagennummern (UG)
  if (formattedNumber.startsWith('-')) {
    return {
      floor: -parseInt(parts[1], 10),
      apartment: parseInt(parts[2], 10)
    };
  }
  
  return {
    floor: parseInt(parts[0], 10),
    apartment: parseInt(parts[1], 10)
  };
};